import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "03bdfb92-8a8d-46b3-be22-ea250939f42b",
    content: "Intertia",
    options: {},
  },
  {
    id: "7834f169-9e6d-4099-a481-a98f07f046b7",
    content: "Viscosity",
    options: {},
  },
  {
    id: "db9c7b4f-a452-48d3-926b-c24d281584df",
    content: "Compressibility",
    options: {},
  },
  {
    id: "2e688f9c-39ef-4294-a51b-5ee678d66e2d",
    content: "Gravity",
    options: {},
  },
  {
    id: "d47e75b0-3fce-4e27-bd96-cc145c203269",
    content: "Electromagnetic induction",
    options: {},
  },
  {
    id: "dd70aae0-6fce-4ccf-a85a-2467e769a5ed",
    content: "Thermal conductivity",
    options: {},
  },
];

export const task: Task = {
  id: "4cb500f1-24ca-4846-83e8-c8e38eb892c4",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 2,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["db9c7b4f-a452-48d3-926b-c24d281584df"],
};
